import React, { Component, useLayoutEffect, useState } from 'react';






export default class MapeaComponent extends React.Component {

	state = {
		layer: null,
		coords: [],
		zoom: 12
	};

	map = null;

	componentDidMount() {
		var x_coord = this.props.x_coord;
		var y_coord = this.props.y_coord;
		var container = "map";


		window.addEventListener('resize', this.updateDimensions);

		var element = document.querySelector(".resource-content>div");
		element.addEventListener("webkitAnimationEnd", this.refreshMap,false);
		element.addEventListener("animationend", this.refreshMap,false);
		element.addEventListener("oanimationend", this.refreshMap,false);

		if (window.M && window.ol && x_coord && y_coord) {
			var M = window.M;
			var ol = window.ol;

			this.map = M.map({
				container: container,
				projection: 'EPSG:3857*m',
				layers: ['OSM'],
				center: '-561256.883497022,4543982.624905937',
				zoom: 6.5,
				resolutions: [51444.18059766173, 25722.090298830866, 12861.045149415433, 6430.522574707717, 3215.2612873538583, 1607.6306436769291, 803.8153218384646, 401.9076609192323, 200.95383045961614, 100.47691522980807, 50.238457614904036, 25.119228807452018, 12.559614403726009, 6.2798072018630045, 3.1399036009315022, 0.3699518004657511]
			});

			var coords = ol.proj.transform([x_coord, y_coord], 'EPSG:4326', 'EPSG:3857');
			this.state.coords = coords;
			this.state.layer = new M.layer.Vector({
				name: "myLayer",
				geometry: 'POINT'
			});

			this.map.addLayers([this.state.layer]);

			var feature = new M.Feature('mifeature', {
				type: 'Feature',
				geometry: {
					type: 'Point',
					coordinates: coords
				}
			});
			this.state.layer.addFeatures([feature]);

			this.centreCoords();

		}
	}

	updateDimensions = () => {

		this.centreCoords();

	};

	refreshMap = () => {
		if (this.map) {
			this.map.refresh();
		}
	}	

	centreCoords() {
		this.map.refresh();
		this.map.setCenter(this.state.coords);
		this.map.setZoom(this.state.zoom);
	}

	render() {
		var mapa = '';
		if (window.M && window.ol && this.props.x_coord && this.props.y_coord) {
			mapa = <div id="map" className="maps"></div>
		}
		return (
			<div>
				{mapa}
			</div>

		);
	}
}


// WEBPACK FOOTER //
// ./src/components/MapeaComponent.jsx